import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  Injector, NgModule, inject, provideAppInitializer 
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { SharedModule } from '../shared/shared.module';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { AuthTokenInterceptor } from './interceptors/auth-token.interceptor';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { LoginPageComponent } from './login-page/login-page.component';
import { InitializeAuth } from './services/auth.service';
import { PasswordResetDialogComponent } from '../password-reset-dialog/password-reset-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MatProgressBarModule,
    MatButtonModule,
    MatDialogModule,
    PasswordResetDialogComponent,
    ReactiveFormsModule
  ],
  providers: [
    CanDeactivateGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    provideAppInitializer(() => {
      const initializerFn = (InitializeAuth)(inject(Injector));
      return initializerFn();
    })
  ],
  declarations: [ LoginPageComponent ],
  exports: [ LoginPageComponent ]
})
export class AuthModule { }
